<template>
  <v-container
    id="data-tables"
    tag="section"
  >
    <v-col
      class="mx-auto"
      cols="8"
    >
      <v-stepper
        v-model="step"
      >
        <v-stepper-header>
          <template
            v-for="(s, index) in steps"
          >
            <v-stepper-step
              :key="'step-'+index"
              :complete="step > index"
              :step="index+1"
              @click="step = index +1"
            >
              {{ s }}
            </v-stepper-step>

            <v-divider
              v-if="step === steps.length-1"
              :key="'divider-'+index"
            />
          </template>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content
            step="1"
          >
            <v-text-field
              v-model="packageNumber"
              :label="$t('package_number')"
              autofocus
              @keypress.enter="scan"
            >
              <template
                v-slot:append-outer
              >
                <v-btn
                  color="primary"
                  style="margin-top: -8px;"
                  :disabled="!packageNumber"

                  @click="scan"
                >
                  {{ $t('continue') }}
                </v-btn>
              </template>
            </v-text-field>
            <v-btn
              color="primary"
              style="margin-top: -8px;"
              @click="step = 2"
            >
              {{ $t('no_package_number') }}
            </v-btn>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-btn
              color="red"
              @click="reset()"
            >
              {{ $t('back') }}
            </v-btn>
            <v-container>
              <base-paginated-select
                :selected="customer"
                endpoint="customers"
                label="Find kunde"
                item-text="name"
                selected-item-text="company_name"
                ignore-selected
                @value-change="c => c ? setCustomer(c) : setCustomer(defaultCustomer)"
              >
                <template v-slot:item="{ item }">
                  {{ item.business ? item.company_name : item.name }}
                </template>
              </base-paginated-select>

              <v-form ref="form">
                <v-container class="py-0">
                  <v-row>
                    <v-col
                      cols="12"
                    >
                      <v-text-field
                        v-model="packageNumber"
                        :label="$t('package_number')"
                        readonly
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      v-if="customer.business"
                      cols="12"
                    >
                      <v-text-field
                        v-model="customer.company_name"
                        :label="$t('company_name')"
                        :error="!!validationErrors.name"
                        :error-messages="validationErrors.name"
                        :rules="rules"
                        @input="validationErrors.name = null"
                      />
                    </v-col>
                    <v-col
                      v-else
                      cols="12"
                    >
                      <v-text-field
                        v-model="customer.name"
                        :label="$t('name')"
                        :error="!!validationErrors.name"
                        :error-messages="validationErrors.name"
                        :rules="rules"
                        @input="validationErrors.name = null"
                      />
                    </v-col>
                    <v-col
                      cols="8"
                    >
                      <v-text-field
                        v-model="customer.shipping_address.street1"
                        :label="$t('addressline', {number: 1})"
                        :error="!!validationErrors.street1"
                        :error-messages="validationErrors.street1"
                        :rules="rules"
                        @input="validationErrors.street1 = null"
                      />
                    </v-col>
                    <v-col
                      cols="4"
                    >
                      <v-text-field
                        v-model="customer.shipping_address.zip_code"
                        :label="$t('zip_code')"
                        :error="!!validationErrors.zip_code"
                        :error-messages="validationErrors.zip_code"
                        :rules="rules"
                        @input="validationErrors.zip_code = null"
                      />
                    </v-col>
                    <v-col
                      cols="8"
                    >
                      <v-text-field
                        v-model="customer.shipping_address.city"
                        :label="$t('city')"
                        :error="!!validationErrors.city"
                        :error-messages="validationErrors.city"
                        :rules="rules"
                        @input="validationErrors.city = null"
                      />
                    </v-col>
                    <v-col cols="4">
                      <base-paginated-select
                        class="mt-5"
                        :selected="customer.shipping_address.country"
                        endpoint="countries"
                        :label="$t('country')"
                        item-text="full_name"
                        item-value="iso"
                        selected-item-text="full_name"
                        @value-change="val => customer.shipping_address.country = val"
                      />
                    </v-col>
                    <v-col
                      cols="6"
                    >
                      <v-text-field
                        v-model="customer.shipping_address.email"
                        :label="$t('email')"
                        type="email"
                        :error="!!validationErrors.email"
                        :error-messages="validationErrors.email"
                        :rules="rules"
                        @input="validationErrors.email = null"
                      />
                    </v-col>
                    <v-col
                      cols="6"
                    >
                      <v-text-field
                        v-model="customer.shipping_address.phone"
                        :label="$t('phone')"
                        type="tel"
                        :error="!!validationErrors.shipping_address.phone"
                        :error-messages="validationErrors.shipping_address.phone"
                        :rules="rules"
                        @input="validationErrors.shipping_address.phone = null"
                      />
                    </v-col>
                    <v-col
                      cols="6"
                    >
                      <v-radio-group v-model="carrier">
                        <v-radio
                          v-for="n in carriers"
                          :key="n.name"
                          :label="`${n.name}`"
                          :value="n"
                        />
                      </v-radio-group>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-container>
            <v-btn
              color="primary"
              :disabled="!customer.id"
              @click="validateReceiver"
            >
              {{ $t('continue') }}
            </v-btn>
          </v-stepper-content>

          <v-stepper-content step="3">
            <div class="text-h4 text-center">
              Skal udsorteres til:
            </div>
            <v-form>
              <v-container class="py-0">
                <v-row>
                  <v-col
                    cols="12"
                  >
                    <div class="text-h3 font-weight-bold text-center">
                      {{ customer.shipping_address.company_name }}
                    </div>
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      v-model="customer.shipping_address.street1"
                      dense
                      readonly
                    />
                  </v-col>
                  <v-col
                    cols="4"
                  >
                    <v-text-field
                      v-model="customer.shipping_address.zip_code"
                      dense
                      readonly
                    />
                  </v-col>
                  <v-col
                    cols="8"
                  >
                    <v-text-field
                      v-model="customer.shipping_address.city"
                      dense
                      readonly
                    />
                  </v-col>
                  <v-col
                    cols="6"
                  >
                    <v-text-field
                      v-model="customer.shipping_address.email"
                      dense
                      type="email"
                      readonly
                    />
                  </v-col>
                  <v-col
                    cols="6"
                  >
                    <v-text-field
                      v-model="customer.shipping_address.phone"
                      dense
                      type="tel"
                      readonly
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
            <v-text-field
              v-model="packageNumber"
              :label="$t('package_number')"
              autofocus
              @keypress.enter="scan"
            >
              <template
                v-slot:append-outer
              >
                <v-btn
                  color="primary"
                  style="margin-top: -8px;"
                  :disabled="!packageNumber"

                  @click="scan"
                >
                  {{ $t('continue') }}
                </v-btn>
              </template>
            </v-text-field>
            <v-btn
              color="primary"
              style="margin-top: -8px;"
              @click="step = 2"
            >
              {{ $t('no_package_number') }}
            </v-btn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-col>
    <base-loading-overlay :loading="loading" />
  </v-container>
</template>

<script>
  import print from 'print-js'
  import { URL_PREFIX } from '@/utils/constants'
  import { handleErrorResponse } from '@/plugins/data'
  import { REQUIRED } from '@/utils/rules'
  import ServerSideValidation from '@/mixins/ServerSideValidation'
  import localStorage from '../../../plugins/localstorage'

  export default {
    mixins: [ServerSideValidation],
    data () {
      return {
        step: 1,
        steps: [
          this.$t('scan'),
          this.$t('find_customer'),
          this.$t('end'),
        ],
        carriers: [
          {
            name: 'Bring private delivery',
            carrier: 'bring',
            product: 'private',
            service: 'delivery',
          },
          {
            name: 'Bring business delivery',
            carrier: 'bring',
            product: 'business',
            service: 'delivery',
          },
          {
            name: 'Danskdistribution business pallet',
            carrier: 'danskdistribution',
            product: 'business',
            service: 'pallet',
          },
        ],
        loading: false,
        carrier: null,
        defaultCountry: { id: 194, full_name: 'Denmark', iso: 'DK', iso3: 'DNK', numeric: '208', region: 'The North', zip_format: '^\\d{4}$', address_format: '{street_name} {street_number}, {zip_code} {city}, {state}, {country_name}', phone_prefix: '45', phone_format: '.+', active: true, created_at: '2018-07-19 12:20:04', updated_at: '2019-11-11 09:47:13', deleted_at: null },
        packageNumber: '',
        customers: [],
        customer: { business: true, shipping_address: { country: this.defaultCountry } },
        defaultCustomer: { business: true, shipping_address: { country: this.defaultCountry } },
        validationErrors: { shipping_address: {} },
        endpoint: 'returns',
      }
    },
    computed: {
      trimmedPackageNumber: function () {
        let splits = this.packageNumber.split('_')

        if (splits.length === 1) { splits = this.packageNumber.split('?') }

        return splits[splits.length - 1]
      },
      receiver: function () {
        const { id, company_name, name, business, shipping_address: { street1, zip_code, city, country: { iso }, email, phone } } = this.customer
        return { customer_id: id, name: business ? company_name : name, street1, zip_code, city, country: iso, email, phone }
      },
      rules () {
        return [REQUIRED]
      },
    },
    watch: {
      step: function () {
        const route = location.hash.split('?')[0]
        window.history.replaceState(null, null, `${route}?step=${this.step}`)
      },
    },
    created: function () {
      const { step } = this.$route.query
      this.step = step || 1
    },
    methods: {
      scan: function () {
        this.handleScannedBarcode(this.trimmedPackageNumber)
      },
      handleScannedBarcode: function (barcode) {
        this.loading = true
        this.$get(`${this.endpoint}/${barcode}`).then(({ data }) => {
          this.loading = false

          this.packageNumber = barcode
          this.customer = { shipping_address: {}, ...data.response_data.customer }
          if (!data.response_data.validation || this.$_.isEmpty(data.response_data.validation)) {
            this.validateReceiver()
            return
          }

          this.setValidationErrors(data.response_data.validation)
          this.step = 2
        })
          .catch(e => {
            if (e?.response?.data?.status === 'SH_0002') {
              this.step = 2
            }
            this.loading = false
          })
      },
      setCustomer: function (val) {
        this.customer = { ...val, shipping_address: { ...val.shipping_address, country: this.defaultCountry } }
      },
      validateReceiver: function () {
        if (!this.$refs.form.validate()) return

        this.loading = true
        this.receiver.carrier = this.carrier

        this.$post(`${this.endpoint}${this.packageNumber ? `/${this.packageNumber}` : ''}`, this.receiver)
          .then(({ data }) => {
            this.loading = false
            const { response_data } = data
            if (response_data.validation && !this.$_.isEmpty(response_data.validation)) {
              this.setValidationErrors(response_data.validation)
            } else {
              this.validationErrors = { shipping_address: {} }

              if (data.response_data.shipment) {
                print({
                  printable: `${URL_PREFIX}/panel/shippinglabels/${data.response_data.shipment.package_number}/label?access_token=${localStorage.get('token')}`,
                  type: 'pdf',
                  onLoadingStart: () => { this.loading = `${this.$t('fetching_label')}...` },
                  onPrintDialogClose: () => { this.loading = null },
                  onPdfOpen: () => { this.loading = null },
                  onLoadingEnd: () => { setTimeout(() => { this.loading = null }, 2000) },

                  onError: handleErrorResponse,
                })
                this.reset()
                return
              }

              this.step = 3
              this.packageNumber = ''
            }
          })
          .catch(() => {
            this.loading = false
          })
      },
      reset: function () {
        this.customer = { shipping_address: { country: {} } }
        this.packageNumber = ''
        this.step = 1
      },
    },
  }
</script>
